var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReassign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1814_1465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8283 6.18771L12.6019 8.41427C12.3749 8.64132 12.0031 8.64452 11.7731 8.41427L9.54654 6.18771C9.31777 5.95894 9.31777 5.58792 9.54654 5.35916C9.77542 5.13028 10.1464 5.13028 10.3752 5.35916L11.6016 6.58539V2.25781C11.6016 1.93474 11.3387 1.67187 11.0156 1.67187H2.8125C2.48886 1.67187 2.22656 1.40958 2.22656 1.08594C2.22656 0.762298 2.48886 0.5 2.8125 0.5H11.0156C11.9849 0.5 12.7734 1.28861 12.7734 2.25781V6.58539L13.9998 5.35916C14.2285 5.13028 14.5996 5.13028 14.8283 5.35916C15.0572 5.58792 15.0572 5.95894 14.8283 6.18771ZM12.1875 14.3281H3.98437C3.6613 14.3281 3.39843 14.0652 3.39843 13.7422V9.4146L4.62478 10.6408C4.85355 10.8697 5.22457 10.8697 5.45333 10.6408C5.68222 10.4121 5.68222 10.041 5.45333 9.81228L3.22689 7.58572C2.99629 7.35512 2.62447 7.35935 2.39811 7.58572L0.171661 9.81228C-0.0572204 10.041 -0.0572204 10.4121 0.171661 10.6408C0.400428 10.8697 0.771445 10.8697 1.00021 10.6408L2.22656 9.4146V13.7422C2.22656 14.7115 3.01517 15.5 3.98437 15.5H12.1875C12.5111 15.5 12.7734 15.2377 12.7734 14.914C12.7734 14.5904 12.5111 14.3281 12.1875 14.3281Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1814_1465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#fff",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReassign);
export default __webpack_public_path__ + "static/media/reassign.f8a684949389d1fd51498bf05b6666a7.svg";
export { ForwardRef as ReactComponent };